import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Twitter, Instagram, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-municipal-dark text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12 border-b border-white/10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-white p-1.5 shrink-0">
                <img src="/logos/escudo-ayuntamiento.png" alt="Escudo Ayuntamiento de San Fernando de Henares" className="w-full h-full object-contain" />
              </div>
              <span className="font-heading font-semibold">Ayuntamiento de San Fernando de Henares</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-4">
              Servicio de recogida de enseres y restos de poda a domicilio, gestionado en
              colaboración con Valoriza Servicios Medioambientales.
            </p>
            <div className="flex items-center gap-4 flex-wrap">
              <img src="/logos/valoriza-negativo.svg" alt="Valoriza Servicios Medioambientales" className="h-6 w-auto opacity-90" />
              <img src="/logos/el-reto-logo.png" alt="El Reto — campaña de reciclaje" className="h-8 w-auto" data-testid="footer-elreto-logo" />
            </div>
            <div className="flex items-center gap-3 mt-5">
              {[Facebook, Twitter, Instagram, Linkedin].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-dorado transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wide text-dorado-light">
              Servicios
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><a href="/#servicios" className="hover:text-white transition-colors">Recogida de enseres</a></li>
              <li><a href="/#servicios" className="hover:text-white transition-colors">Recogida de poda</a></li>
              <li><Link to="/punto-limpio" className="hover:text-white transition-colors">Punto Limpio Móvil</Link></li>
              <li><Link to="/solicitud" className="hover:text-white transition-colors">Solicitar recogida</Link></li>
              <li><Link to="/consultar" className="hover:text-white transition-colors">Consultar mi solicitud</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wide text-dorado-light">
              Enlaces
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/aviso-legal" className="hover:text-white transition-colors">Aviso legal</Link></li>
              <li><Link to="/privacidad" className="hover:text-white transition-colors">Política de privacidad</Link></li>
              <li><Link to="/cookies" className="hover:text-white transition-colors">Política de cookies</Link></li>
              <li><Link to="/admin" className="hover:text-white transition-colors">Acceso administración</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wide text-dorado-light">
              Contacto
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-dorado-light" />
                Plaza de España 1, 28830 San Fernando de Henares, Madrid
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 shrink-0 text-dorado-light" />
                <a href="tel:916751810" className="hover:text-white transition-colors">916 75 18 10</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 shrink-0 text-dorado-light" /> recogidas@sanfernandodehenares.es
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Ayuntamiento de San Fernando de Henares — Servicio gestionado por Valoriza</p>
          <p>Portal Recogida SFH v1</p>
        </div>
      </div>
    </footer>
  );
}
